import { render, staticRenderFns } from "./BoxOfficeModule.vue?vue&type=template&id=446a73ae&"
import script from "./BoxOfficeModule.vue?vue&type=script&lang=js&"
export * from "./BoxOfficeModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports